import { useEffect } from 'react';

import NoSleep from '@uriopass/nosleep.js';

import { handleNativeMessage as handleNativeMessageLogic, setupNativeMessageListener } from '@src/bridge/receiver';
import { useClarity } from '@src/hooks';

import { isWebView } from '@src/helpers';
import ErrorInspector from '@src/utils/errorInspector';

const useAppInit = () => {
  // Initialize Microsoft Clarity analytics
  useClarity();
  useEffect(() => {
    const handleUserInteraction = () => {
      try {
        const noSleep = new NoSleep();
        noSleep.enable();
      } catch (err) {
        console.error(err);
      }
      document.removeEventListener('click', handleUserInteraction);
    };

    document.addEventListener('click', handleUserInteraction);

    return () => {
      document.removeEventListener('click', handleUserInteraction);
    };
  }, []);

  useEffect(() => {
    ErrorInspector.initialize();
  }, []);

  useEffect(() => {
    setupNativeMessageListener();
  }, []);

  useEffect(() => {
    if (!isWebView()) return;

    function handlePostMessage(event: any) {
      // Optionally, check event.origin for security!
      handleNativeMessageLogic(event.data);
    }
    window.addEventListener('message', handlePostMessage);
    return () => window.removeEventListener('message', handlePostMessage);
  }, []);
};

export default useAppInit;
